export class RoleUsage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "inUse",
            "baseName": "inUse",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reasons",
            "baseName": "reasons",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RoleUsage.attributeTypeMap;
    }
    constructor() {
    }
}
